/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    resource_data: string;
}

interface IOutput {
    resource_ids: string[];
}

export const saveResource = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.SAVE_RESOURCE, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const saveResourceSync = fetchDataSync(saveResource);
